import React from "react";
import Education from "../Components/education/Education";
import TopBar from "../Components/common/TopBar";
import Spacer2 from "../Components/common/Spacer2";

function EducationPage() {
  return (
    <>
      <TopBar />
      <Spacer2 />
      <Education />
    </>
  );
}

export default EducationPage;
